import { render } from "./ThemePalettes.vue.js?vue&type=template&id=a90bdf70&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettes.vue?vue&type=template&id=a90bdf70&scoped=true"
import script from "./ThemePalettes.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettes.vue?vue&type=script&lang=js"
export * from "./ThemePalettes.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettes.vue?vue&type=script&lang=js"

import "./ThemePalettes.vue.scss?vue&type=style&index=0&id=a90bdf70&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettes.vue?vue&type=style&index=0&id=a90bdf70&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90bdf70"],['__file',"src/Web/scripts/pages/publication/ThemePalettes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a90bdf70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a90bdf70', __exports__)) {
    api.reload('a90bdf70', __exports__)
  }
  
  module.hot.accept("./ThemePalettes.vue.js?vue&type=template&id=a90bdf70&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettes.vue?vue&type=template&id=a90bdf70&scoped=true", () => {
    api.rerender('a90bdf70', render)
  })

}


export default __exports__